import { Star } from 'lucide-react';

export default function TrustBanner() {
  return (
    <section data-testid="trust-banner" className="border-y border-essenya-border bg-white">
      <div className="container-essenya py-8 flex justify-center">
        <div className="flex items-center gap-3" data-testid="trust-customers">
          <div className="font-display text-3xl flex-shrink-0">8K+</div>
          <div>
            <p className="text-sm font-medium">Clienti soddisfatti</p>
            <p className="text-essenya-text text-xs">Spedizioni in tutta Italia · Made in Italy</p>
          </div>
        </div>
      </div>
    </section>
  );
}
